module.exports = __webpack_public_path__ + "static/media/use-lounge-modal-background.c8724c9e.png";